module.exports = __webpack_public_path__ + "img/engraneNaranja.031f2c8d.svg";